import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SuccessEvent, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { intersectionWith, map, uniq } from 'lodash';
import { Subject } from 'rxjs';
import { NotifyType } from '../../../../core/enums/NotifyType';
import { IPrductCategory, IPrductConfiguration, IPrductSubCategory, IPrductMapping, IV6Product, IBBPrductCategory, IBBProductHierarchies, IBBProductSubCategory, IBBPrductConfiguration, BBPrductCategory, BBProductSubCategory, BBConfigModal, IPTempCodes } from '../../../../core/models';
import { AdminService } from '../../../../core/services/admin.service';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { ProductService } from '../../../../core/services/product.service';

@Component({
  selector: 'app-product-setup',
  templateUrl: './product-setup.component.html',
  styleUrls: ['./product-setup.component.scss']
})
export class ProductSetupComponent implements OnInit {
  //#region member variables
  imageCategorySrc: string;
  imageSubCategorySrc: string;
  imageConfigSrc: string;
  productMappingLoading: boolean;
  categoryLoading: boolean;
  subCategoryLoading: boolean;
  configurationLoading: boolean;
  productMappingGridView: GridDataResult;



  productCategory: IPrductCategory[] = [];
  productSubCategory: IPrductSubCategory[] = [];
  productSubCategoryByCategoryId: IPrductSubCategory[] = [];
  productConfiguration: IPrductConfiguration[] = [];
  productConfigurationByProductSubCategory: IPrductConfiguration[] = [];


  productSubCategory_1: IBBProductSubCategory[] = [];
  productConfiguration_1: IBBPrductConfiguration[] = [];

  public subCategoryDescription: any[] = [{ id: 1, description: "" }];
  products: IV6Product[] = [];
  availableProducts: IV6Product[] = [];
  disableProductSelect: boolean;
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif"],
  };
  getLanguages: any;
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
  //#endregion
  constructor(private adminService: AdminService, private productService: ProductService, private languageService: LanguageTranslationService,
    private appNotifyService: AppNotifyService,) { }

  ngOnInit() {
    this.initProductHierarchyData();
    this.languageService.getLanguages().subscribe(response => {
      this.getLanguages = response;
    })

  }

  //#region pagination, sorting,filtering for grid

  public productMappingGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'languageCode',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };



  private bindProductMappingGrid(): void {
    const data = this.adminService.productMappingData.filter(t => t.templateId != '0');
    this.productMappingGridView = process(data, this.productMappingGridstate);
  }



  protected productMappingGridSortChange(sort: SortDescriptor[]): void {
    this.productMappingGridstate.sort = sort;
    this.bindProductMappingGrid();
  }
  protected productMappingGridPageChange({ skip, take }: PageChangeEvent): void {
    this.productMappingGridstate.skip = skip;
    this.productMappingGridstate.take = take;
    this.bindProductMappingGrid();
  }

  public productMappingDataStateChange(state: DataStateChangeEvent): void {
    this.productMappingGridstate = state;
    this.bindProductMappingGrid();
  }




  //#endregion
  //#region Grid data binding
  private loadProductMappingGrid(): void {
    this.productMappingLoading = true;

    this.adminService.getProductMapping().subscribe((response) => {
      console.log(response);
      this.loadCategoryGrid(response);
      this.loadSubCategoryGrid(response);
      this.loadConfigurationGrid(response);
      this.productMappingLoading = false;
    });
    //this.productService.getAllProductTemplate().subscribe((response) => {
    //  this.products = response;
    //  //this.availableProducts = this.products.filter(p => p.productId === 0); // remove condition 
    //  this.availableProducts = this.products;
    //  this.availableProducts = this.availableProducts.length > 20 ? this.availableProducts.slice(0, 20) : this.availableProducts;
    //});
  }

  //#region new on 1st June 2022

  //#endregion


  onTabSelect($event) {
    if ($event.index == 1) {
      this.bindSubCategoryGrid();
    }
    else if ($event.index == 2) {
      this.bindConfigurationGrid();
    }
    else if ($event.index == 3) {
      this.bindProductMappingGrid();
    }
  }
  //#endregion

  //#region ProductCategory

  //#endregion
  //#region paging sorting filtering

  //#endregion
  //#region save/edit dialog








  languageChange(event) {
    this.categoryModel.languageCode = event.languageCode;
  }
  //handleFileInputproductCategory(files) {

  //}
  categoryImageSelected(evt: SelectEvent) {

  }
  isCategoryFileUploaded: boolean = false;
  categoryImageUploadSuccess(evt: SuccessEvent) {
    this.categoryModel.imageUrl = evt.response.body.paths[0];
    this.isCategoryFileUploaded = true;
  }
  resetProductCategory() {
    this.imageCategorySrc = "";
    this.isCategoryFileUploaded = false;
    this.productCategoryDialog.isEmptyName = false;
    this.productCategoryDialog.isEmptyDescription = false;
    this.productCategoryDialog.isEmptyLanguage = false;
    return {
      id: 0,
      name: null,
      imageUrl: null,
      description: null,
      isActive: false,
      languageCode: "",
      categoryUniqueID: 0
    }

  }


  //#endregion
  //#endregion

  //#region Product SubCategory


  //#region Add Edit Sub Category


  subCategoryLanguageChange(event) {
    this.subCategoryModel.languageCode = event.languageCode;
    this.subCategoryModel.productCategoryName = null;
    this.subCategoryModel.productCategoryUniqueId = null;
    this.bindCategoryDataOnLanguage(event.languageCode);
  }
  handleFileInputproductSubCategory(files) {

  }

  productCategoryDropData: IBBPrductCategory[] = [];
  bindCategoryDataOnLanguage(languageCode) {
    this.productCategoryDropData = [];
    this.productCategoryDropData = this.productCategory_1.filter(r => r.languageCode == languageCode && r.isActive);
  }
  productSubCategoryProductCategorySelectionChange(event) {
    this.subCategoryModel.productCategoryUniqueId = event.uniqueId;
    this.subCategoryModel.productCategoryName = event.name;
  }
  resetsubCategoryModel() {
    this.imageSubCategorySrc = "";
    this.isSubCategoryFileUploaded = false;
    this.subCategoryDescription = [{ id: 1, description: "" }];
    this.productSubCategoryDialog.isEmptyProductCategory = false;
    this.productSubCategoryDialog.isEmptyName = false;
    this.productSubCategoryDialog.isEmptyDescription = false;
    this.productSubCategoryDialog.isEmptyLanguage = false;
    return {
      categoryId: null,
      categoryName: null,
      productCategory: {},
      id: 0,
      name: null,
      imageUrl: null,
      description: null,
      isActive: false,
      languageCode: "",
      subCategoryUniqueID: 0

    };
  }


  addSubCategoryDescription() {
    this.productSubCategoryDialog.description = true;
    if (this.subCategoryDescription[this.subCategoryDescription.length - 1].description == "") {
      this.productSubCategoryDialog.isEmptyDescription = true;
      return;
    }
    this.productSubCategoryDialog.isEmptyDescription = false;
    this.subCategoryDescription.push({ id: this.subCategoryDescription.length + 1, description: "" });
  }
  removeSubCategoryDescription(i: number) {
    this.productSubCategoryDialog.isEmptyDescription = false;
    this.subCategoryDescription.splice(i, 1);
  }
  subCategoryImageSelected(evt: SelectEvent) {

  }
  isSubCategoryFileUploaded: boolean = false;
  subCategoryImageUploadSuccess(evt: SuccessEvent) {
    this.subCategoryModel.productImageUrl = evt.response.body.paths[0];
    this.isSubCategoryFileUploaded = true;
  }
  //#endregion
  //#endregion

  //#region ProductConfiguration
  public configurationGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'categoryId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  //#region Bind Grid

  //#endregion
  //#region sorting/pagging/filtering

  //#endregion
  //#region - Add/Edit Dialog



  resetConfigurationModel() {
    this.imageConfigSrc = "";
    this.isConfigFileUploaded = false;
    return {
      categoryId: null,
      categoryName: null,
      categoryImageUrl: null,
      productSubCategoryId: null,
      subCategoryName: null,
      subCategoryImageUrl: null,
      id: 0,
      name: null,
      imageUrl: null,
      description: null,
      isActive: true,

      //name: null,
      productCategory: null,
      productSubCategory: null,
      //description: null,
      //imageUrl: null,
      //isActive: false
      product: null,
      languageCode: '',
      configUniqueID: 0
    };
  }

  infoMessage: any = null;

  loadSubCategory() {
    if (this.configurationModel.productCategory) {
      //this.productSubCategoryByCategoryId = this.productSubCategory_1.filter(r => r.productCategoryId = this.configurationModel.productCategory.uniqueId)
      this.productSubCategoryByCategoryId = this.productSubCategory.filter(r => r.productCategoryId === this.configurationModel.productCategory.id);
      if (this.configurationModel.productSubCategory) {
        this.configurationModel.productSubCategory = this.productSubCategoryByCategoryId.find(r => r.id === this.configurationModel.productSubCategory.id);
      }
    } else {
      this.productSubCategoryByCategoryId = [];
      this.configurationModel.productSubCategory = null;

    }
  }
  productConfigurationDialog = this.resetProductConfigurationDialog()
  resetProductConfigurationDialog() {
    return {
      title: "Add",
      opened: false,
      isSubmitted: false,
      productCategoryLbl: "Product Category",
      productSubCategoryLbl: "Product Subcategory",
      nameLbl: "Name",
      descriptionLbl: "Description",
      productCategoryData: [],
      productSubCategoryData: [],
      productSubCategoryByCategoryId: [],
      isEmptyProductSubCategory: false,
      isEmptyProductCategory: false,
      isEmptyName: false,
      isEmptyDescription: false,
      isActiveLbl: "Active",
      imageUrlLbl: "ImageURL",
      saveInProcess: false,
      productLbl: "Product",
      languageCode: '',
      isEmptyLanguage: false,
      isEmptyTemplate: false
    };
  }




  handleFileInputproductConfiguration(files) {

  }

  //productSelectionChange(product: any) { }

  configurationImageSelected(evt: SelectEvent) {

  }
  isConfigFileUploaded: boolean = false;
  configurationImageUploadSuccess(evt: SuccessEvent) {
    this.configModal_1.imageUrl = evt.response.body.paths[0];
    this.isConfigFileUploaded = true;
  }
  //#endregion


  //#endregion


  //#region -Product Template Add/Edit Dialog
  addProductTemplate() {
    this.productTemplateDialog = this.resetProductTemplateDialog();
    this.productTemplateDialog.opened = true;
    this.productTemplateDialog.title = "Add";
    this.templateModel = this.resetTemplateModel();
  }
  templateModel: any = this.resetTemplateModel();

  resetTemplateModel() {
    return {
      categoryId: null,
      categoryName: null,
      categoryImageUrl: null,
      productSubCategoryId: null,
      subCategoryName: null,
      subCategoryImageUrl: null,
      id: 0,
      name: null,
      imageUrl: null,
      description: null,
      isActive: false,

      //name: null,
      productCategory: {},
      productSubCategory: {},
      productConfiguration: {},
      //description: null,
      //imageUrl: null,
      //isActive: false

    };
  }

  editproductTemplate(dataItem) {
    this.productTemplateDialog = this.resetProductTemplateDialog();
    this.templateModel = dataItem;
    this.templateModel.id = dataItem.templateId;
    this.templateModel.name = dataItem.templateName;
    this.templateModel.isActive = true;
    this.templateModel.productCategory = this.productCategory.find(r => r.id === dataItem.categoryId);
    if (this.templateModel.productCategory) {
      this.loadSubCategoryTemplate();
      this.templateModel.productSubCategory = this.productSubCategoryByCategoryId.find(r => r.id === dataItem.subCategoryId);
    }
    if (this.templateModel.productSubCategory) {
      this.loadConfigurationTemplate();
      this.templateModel.productConfiguration = this.productConfigurationByProductSubCategory.find(r => r.id === dataItem.configId);
    }
    this.productTemplateDialog.opened = true;
    this.productTemplateDialog.title = "Edit";
    console.log(dataItem);


  }
  loadSubCategoryTemplate() {
    if (this.templateModel.productCategory) {
      this.productSubCategoryByCategoryId = this.productSubCategory.filter(r => r.productCategoryId === this.templateModel.productCategory.id);
      if (this.templateModel.productSubCategory) {
        this.templateModel.productSubCategory = this.productSubCategoryByCategoryId.find(r => r.id === this.templateModel.productSubCategory.id);
      }
    } else {
      this.productSubCategoryByCategoryId = [];
      this.templateModel.productSubCategory = null;
    }
    this.loadConfigurationTemplate();
  }
  loadConfigurationTemplate() {
    if (this.templateModel.productSubCategory) {
      this.productConfigurationByProductSubCategory = this.productConfiguration.filter(r => r.productSubCategoryId === this.templateModel.productSubCategory.id);
      if (this.templateModel.productConfiguration) {
        this.templateModel.productConfiguration = this.productConfigurationByProductSubCategory.find(r => r.id === this.templateModel.productConfiguration.id);
      }
    } else {
      this.productConfigurationByProductSubCategory = [];
      this.templateModel.productConfiguration = null;
    }

  }
  productTemplateDialog: any = this.resetProductTemplateDialog();
  resetProductTemplateDialog() {
    return {
      title: "Add",
      opened: false,
      isSubmitted: false,
      productCategoryLbl: "Product Category",
      productSubCategoryLbl: "Product SubCategory",
      productConfigurationLbl: "Product Configuration",
      nameLbl: "Name",
      imageUrlLbl: "ImageURL",
      isActiveLbl: "Active",
      productCategoryData: [],
      productSubCategoryData: [],
      isEmptyProductSubCategory: false,
      isEmptyProductCategory: false,
      isEmptyName: false,
      isEmptyProductConfiguration: false,
      saveInProcess: false,
    }
  }
  productTemplateProductCategorySelectionChange(event) {
    this.templateModel.productCategory = event;
    this.loadSubCategoryTemplate();
  }
  productTemplateProductProductSubCategorySelectionChange(event) {
    this.templateModel.productSubCategory = event;
    this.loadConfigurationTemplate();
    this.validateProductTemplateForm();
  }
  validateProductTemplateForm(): boolean {
    if (this.productTemplateDialog.isSubmitted) {
      let isInvalid = false;
      if (this.templateModel.productCategory) {
        if (!this.templateModel.productCategory.id) {
          this.productTemplateDialog.isEmptyProductCategory = true;
          isInvalid = true;
        } else {
          this.productTemplateDialog.isEmptyProductCategory = false;
        }
      } else {
        this.productTemplateDialog.isEmptyProductCategory = true;
        isInvalid = true;
      }
      if (this.productSubCategoryByCategoryId.length > 0) {
        if (this.templateModel.productSubCategory) {
          if (!this.templateModel.productSubCategory.id) {
            this.productTemplateDialog.isEmptyProductSubCategory = true;
            isInvalid = true;
          } else {
            this.productTemplateDialog.isEmptyProductSubCategory = false;
          }
        } else {
          this.productTemplateDialog.isEmptyProductSubCategory = true;
          isInvalid = true;
        }

      }
      if (this.productConfigurationByProductSubCategory.length > 0) {
        if (this.templateModel.productConfiguration) {
          if (!this.templateModel.productConfiguration.id) {
            this.productTemplateDialog.isEmptyProductConfiguration = true;
            isInvalid = true;
          } else {
            this.productTemplateDialog.isEmptyProductConfiguration = false;
          }
        } else {
          this.productTemplateDialog.isEmptyProductConfiguration = true;
          isInvalid = true;
        }
      }
      if (!this.templateModel.name) {
        this.productTemplateDialog.isEmptyName = true;
        isInvalid = true;
      } else {
        this.productTemplateDialog.isEmptyName = false;
      }
      if (isInvalid) {
        return false;
      }
      return true;
    }
  }
  handleFileInputProductTemplate(files) {

  }
  saveProductTemplate() {
    this.productTemplateDialog.isSubmitted = true;

    if (!this.validateProductTemplateForm()) {
      return;
    }

    const body = {
      id: +this.templateModel.id,
      name: this.templateModel.name,
      imageUrl: this.templateModel.imageUrl,
      isActive: this.templateModel.isActive,
      subCategoryId: +this.templateModel.productSubCategory.id,
      configurationId: +this.templateModel.productConfiguration.id,
    }

    this.productTemplateDialog.saveInProcess = true;


  }

  //#endregion



  //#region Complete New Rewrite
  //#region Common New Init

  initProductHierarchyData(): void {
    this.productMappingLoading = true;
    this.adminService.getProductMapping().subscribe((response) => {
      //console.log(response);
      this.initCategoryData(response);
      this.initSubCatData(response);
      this.initConfigData(response);
      this.loadCategoryGrid(response);
      this.loadSubCategoryGrid(response);
      this.loadConfigurationGrid(response);
      this.productTemplates_1 = response.templateProductCodes;
      this.productMappingLoading = false;
    });
  }
  initCategoryData(rp: IBBProductHierarchies) {
    this.productCategory_1 = rp.categories;
  }
  initSubCatData(rp: IBBProductHierarchies) {
    this.productSubCategory_1 = rp.subCats;
    this.prepareSubCatObjectsForDisplay();
    console.log(this.productSubCategory_1);
    //this.productSubCategory_1.forEach((el, index) => {
    //  let cat = this.productCategory_1.find(x => x.uniqueId == el.productCategoryUniqueId);
    //  if (cat) {
    //    el.productCategoryName = cat.name;
    //  }
    //})
    //console.log(this.productSubCategory_1);
  }
  prepareSubCatObjectsForDisplay() {
    this.productSubCategory_1.forEach((el, index) => {
      let cat = this.productCategory_1.find(x => x.uniqueId == el.productCategoryUniqueId);
      if (cat) {
        el.productCategoryName = cat.name;
        el.productCategoryImageUrl = cat.imageUrl;
      }
    })
  }
  initConfigData(rp: IBBProductHierarchies) {
    this.productConfiguration_1 = rp.configs;
    this.prepareConfigObjectsForDisplay();
    console.log(this.productConfiguration_1);
  }

  prepareConfigObjectsForDisplay() {
    this.productConfiguration_1.forEach((el, index) => {
      let subCat = this.productSubCategory_1.find(x => x.uniqueId == el.subCatUniqueId);
      if (subCat) {
        let cat = this.productCategory_1.find(x => x.uniqueId == subCat.productCategoryUniqueId);
        el.subCatName = subCat.name;
        el.subCatImageUrl = subCat.productImageUrl;
        if (cat) {
          el.catName = cat.name;
          el.catUniqueId = cat.uniqueId;
          el.catImageUrl = cat.imageUrl;
        }
      }
    })
  }


  //mapCatPropsOfSubCats() {
  //  this.productSubCategory_1.forEach((el, index) => {
  //    let cat = this.productCategory_1.find(x => x.uniqueId == el.productCategoryUniqueId);
  //    if (cat) {
  //      el.productCategoryName = cat.name;
  //    }
  //  })
  //}

  //#endregion
  //#region New Prod Cat  
  categoryLbl = {
    name: "Category Name",
    image: "Category Image",
    description: "Category Description",
    action: "Action",
    isActive: "Active"
  }
  categoryGridView: GridDataResult;
  productCategory_1: IBBPrductCategory[] = [];
  productTemplates_1: IPTempCodes[] = [];
  categoryGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'languageCode',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  loadCategoryGrid(rp: IBBProductHierarchies): void {
    this.categoryLoading = true;
    //this.productCategory_1 = rp.categories;
    /*this.adminService.productMappingData.map((obj) => ({
    id: obj.categoryId, description: obj.categoryDescription, imageUrl: obj.categoryImageUrl, name: obj.categoryName, isActive: obj.isCategoryActive, categoryLanguageCode: obj.categoryLanguageCode
    , categoryUniqueID: obj.categoryUniqueID
  })).filter(
    (thing, i, arr) => arr.findIndex(t => t.categoryUniqueID === thing.categoryUniqueID && t.categoryLanguageCode === thing.categoryLanguageCode) === i
  );*/
    this.bindCategoryGrid();
    this.categoryLoading = false;
  }
  bindCategoryGrid(): void {
    console.log(this.productCategory_1);
    this.categoryGridView = process(this.productCategory_1, this.categoryGridstate);
  }
  categoryGridSortChange(sort: SortDescriptor[]): void {
    this.categoryGridstate.sort = sort;
    this.bindCategoryGrid();
  }
  categoryGridPageChange({ skip, take }: PageChangeEvent): void {
    this.categoryGridstate.skip = skip;
    this.categoryGridstate.take = take;
    this.bindCategoryGrid();
  }
  categoryDataStateChange(state: DataStateChangeEvent): void {
    this.categoryGridstate = state;
    this.bindCategoryGrid();
  }
  categoryModel: IBBPrductCategory;
  productCategoryDialog: any = {
    title: "Add Category",
    opened: false,
    isSubmitted: false,
    nameLbl: "Category Name",
    descriptionLbl: "Description",
    isEmptyName: false,
    isEmptyDescription: false,
    isActiveLbl: "Active",
    imageUrlLbl: "Image",
    saveInProcess: false,
    isEmptyLanguage: false
  }
  initEditCategoryModal(dataItem: IBBPrductCategory) {
    this.categoryModel = dataItem;
    //this.productCategoryDialog.isEmptyName = false;
    //this.productCategoryDialog.isEmptyDescription = false;
    //this.productCategoryDialog.isEmptyLanguage = false;
    this.shouldShowCatModalError = true;
    this.productCategoryDialog.opened = true;
    this.productCategoryDialog.title = "Edit Category";
    this.imageCategorySrc = this.categoryModel.imageUrl;
    this.categoryModel.languageCode = dataItem.languageCode;

  }
  initAddProductCategoryModal() {
    this.categoryModel = new BBPrductCategory();//this.resetProductCategory();
    //this.productCategoryDialog.isEmptyName = false;
    //this.productCategoryDialog.isEmptyDescription = false;
    //this.productCategoryDialog.isEmptyLanguage = false;
    this.imageCategorySrc = null;
    this.shouldShowCatModalError = false;
    this.productCategoryDialog.opened = true;
    this.productCategoryDialog.title = "Add Categories";
  }
  shouldShowCatModalError: boolean = false;
  validateProductCategoryForm(): boolean {
    let isValid = true;
    this.productCategoryDialog.isEmptyName = false;
    this.productCategoryDialog.isEmptyDescription = false;
    this.productCategoryDialog.isEmptyLanguage = false;

    if (!this.categoryModel.name) {
      this.productCategoryDialog.isEmptyName = true;
    }
    if (!this.categoryModel.description) {
      this.productCategoryDialog.isEmptyDescription = true;
    }
    if (!this.categoryModel.languageCode) {
      this.productCategoryDialog.isEmptyLanguage = true;
    }
    if (this.productCategoryDialog.isEmptyName
      || this.productCategoryDialog.isEmptyDescription
      || this.productCategoryDialog.isEmptyLanguage) {
      isValid = false;
    }
    return isValid;
  }
  saveProductCategory() {
    this.shouldShowCatModalError = true;
    if (!this.validateProductCategoryForm()) return;
    if (this.isCategoryFileUploaded == false) {
      this.categoryModel.imageUrl = null;
    }
    const body = {
      categoryUniqueID: this.categoryModel.uniqueId || 0,
      id: this.categoryModel.id || 0,
      name: this.categoryModel.name,
      imageUrl: this.categoryModel.imageUrl,
      description: this.categoryModel.description,
      isActive: this.categoryModel.isActive,
      languageCode: this.categoryModel.languageCode
    }
    this.adminService.saveProductCategory(body).subscribe(result => {
      console.log(result);
      this.updateCategoryList(result);
      this.productCategoryDialog.saveInProcess = false;
      this.productCategoryDialog.opened = false;
      this.bindCategoryGrid();
      this.categoryModel = new BBPrductCategory();
    }, (error) => {
      this.productCategoryDialog.saveInProcess = false;
    });
  }
  updateCategoryList(item: IBBPrductCategory) {
    if (item) {
      const tempIndex = this.productCategory_1.findIndex(r => r.uniqueId === item.uniqueId);
      if (tempIndex > -1) {
        this.productCategory_1.splice(tempIndex, 1, item);
      } else {
        this.productCategory_1.splice(0, 0, item);
      }
    }
  }

  //#endregion

  //#region New Product Sub Cat
  subCategoryGridView: GridDataResult;
  subCategoryLbl = {
    subcategoryName: "Subcategory Name",
    subCategoryImage: "Subcategory Image",
    description: "Description",
    categoryName: "Category Name",
    categoryImage: "Category Image",
    action: "Action",
    isActive: "Active"
  }
  subCategoryGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'languageCode',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  bindSubCategoryGrid(): void {
    console.log(this.productSubCategory_1);
    this.subCategoryGridView = process(this.productSubCategory_1, this.subCategoryGridstate);
  }
  loadSubCategoryGrid(rp: IBBProductHierarchies): void {
    this.subCategoryLoading = true;
    //this.productSubCategory_1 = rp.subCats;

    /*this.adminService.productMappingData.map((obj) => ({
    id: obj.subCategoryId, description: obj.subCategoryDescription, imageUrl: obj.subCategoryImageUrl, name: obj.subCategoryName, isActive: obj.isSubCategoryActive, subCategoryLanguageCode: obj.subCategoryLanguageCode,
    productCategoryId: obj.categoryId, categoryName: obj.categoryName, categoryImageUrl: obj.categoryImageUrl,
    subCategoryUniqueID: obj.subCategoryUniqueID
  })).filter(
    (thing, i, arr) => arr.findIndex(t => t.subCategoryUniqueID === thing.subCategoryUniqueID && t.subCategoryLanguageCode === thing.subCategoryLanguageCode) === i
  );*/
    this.bindSubCategoryGrid();
    this.subCategoryLoading = false;
  }
  subCategoryGridSortChange(sort: SortDescriptor[]): void {
    this.subCategoryGridstate.sort = sort;
    this.bindSubCategoryGrid();
  }
  subCategoryGridPageChange({ skip, take }: PageChangeEvent): void {
    this.subCategoryGridstate.skip = skip;
    this.subCategoryGridstate.take = take;
    this.bindSubCategoryGrid();
  }
  subCategoryDataStateChange(state: DataStateChangeEvent): void {
    this.subCategoryGridstate = state;
    this.bindSubCategoryGrid();
  }
  productSubCategoryDialog: any = {
    title: "Add Subcategory",
    categoryLbl: "Category",
    opened: false,
    isSubmitted: false,
    nameLbl: "Subcategory Name",
    descriptionLbl: "Description",
    productCategoryData: [],
    isEmptyProductCategory: false,
    isEmptyName: false,
    isEmptyDescription: false,
    isActiveLbl: "Active",
    imageUrlLbl: "ImageURL",
    saveInProcess: false,
    isEmptyLanguage: false
  }
  subCategoryModel: IBBProductSubCategory;
  catForSubCatEditModal: any;
  shouldShowSubCatModalError: boolean = false;
  validateProductSubCategoryForm(): boolean {
    let isValid = true;
    this.productSubCategoryDialog.isEmptyProductCategory = false;
    this.productSubCategoryDialog.isEmptyName = false;
    this.productSubCategoryDialog.isEmptyDescription = false;
    this.productSubCategoryDialog.isEmptyLanguage = false;
    if (!this.subCategoryModel.name) {
      this.productSubCategoryDialog.isEmptyName = true;
    }
    if (!this.subCategoryDescription[0].description) {
      this.productSubCategoryDialog.isEmptyDescription = true;
    }
    if (this.subCategoryModel.productCategoryUniqueId == null || this.subCategoryModel.productCategoryUniqueId == 0) {
      this.productSubCategoryDialog.isEmptyProductCategory = true;
    }
    if (!this.subCategoryModel.languageCode) {
      this.productSubCategoryDialog.isEmptyLanguage = true;
    }
    if (this.productSubCategoryDialog.isEmptyName
      || this.productSubCategoryDialog.isEmptyProductCategory
      || this.productSubCategoryDialog.isEmptyLanguage
      || this.productSubCategoryDialog.isEmptyDescription
    ) {
      isValid = false;
    }
    return isValid;
  }
  addProductSubCategory() {
    this.shouldShowSubCatModalError = false;
    this.productSubCategoryDialog.opened = true;
    this.productSubCategoryDialog.title = "Add Subcategories";
    this.subCategoryModel = new BBProductSubCategory();
    this.bindCategoryDataOnLanguage(localStorage.getItem('language'));
    this.imageSubCategorySrc = null;
    this.catForSubCatEditModal = null;
  }
  editProductSubCategory(dataItem: IBBProductSubCategory) {
    this.shouldShowSubCatModalError = true;
    var description = dataItem.description.split("abcdTest ");
    this.subCategoryDescription = [];
    description.forEach(function (des) {
      this.subCategoryDescription.push({
        id: this.subCategoryDescription.length + 1,
        description: des
      });
    }.bind(this));
    this.subCategoryModel = dataItem;
    this.catForSubCatEditModal = this.productCategory_1.find(r => r.uniqueId === dataItem.productCategoryUniqueId);
    this.productSubCategoryDialog.opened = true;
    this.productSubCategoryDialog.title = "Edit Subcategories";
    this.imageSubCategorySrc = this.subCategoryModel.productImageUrl;
    this.subCategoryModel.languageCode = dataItem.languageCode;
    this.bindCategoryDataOnLanguage(this.subCategoryModel.languageCode);
  }
  saveSubProductCategory() {
    this.shouldShowSubCatModalError = true;
    if (!this.validateProductSubCategoryForm()) return;
    const description = this.subCategoryDescription.map(d => { return d.description }).join("abcdTest ");
    if (this.isSubCategoryFileUploaded == false) {
      this.subCategoryModel.productImageUrl = null;
    }
    const body = {
      id: +this.subCategoryModel.id || 0,
      name: this.subCategoryModel.name,
      productImageUrl: this.subCategoryModel.productImageUrl,
      description: description,//this.subCategoryModel.description,
      isActive: this.subCategoryModel.isActive,
      productCategoryId: +this.catForSubCatEditModal.uniqueId,
      productCategoryName: this.catForSubCatEditModal.name,
      languageCode: this.subCategoryModel.languageCode,
      subCategoryUniqueID: this.subCategoryModel.uniqueId || 0
    }


    this.productSubCategoryDialog.saveInProcess = true;
    this.adminService.saveProductSubCategory(body)
      .subscribe(result => {
        console.log(result);
        this.productSubCategoryDialog.saveInProcess = false;
        this.addUpdateProductSubCategory(result);
        this.prepareSubCatObjectsForDisplay();
        this.productSubCategoryDialog.opened = false;
        this.bindSubCategoryGrid();

      }, (error) => {
        this.productConfigurationDialog.saveInProcess = false;
      });
  }
  addUpdateProductSubCategory(item: IBBProductSubCategory) {
    if (item) {
      const tempIndex = this.productSubCategory_1.findIndex(r => r.uniqueId === item.uniqueId);
      if (tempIndex > -1) {
        this.productSubCategory_1.splice(tempIndex, 1, item);
      } else {
        this.productSubCategory_1.splice(0, 0, item);
      }
    }
  }
  //#endregion

  //#region New Product Config
  configurationGridView: GridDataResult;
  productMappingLbl = {
    categoryName: "Category Name",
    categoryImage: "Category Image",
    subCategoryName: "Subcategory Name",
    subCategoryImage: "Subcategory Image",
    configName: "Config Name",
    configImage: "Config Image",
    isActive: "IsActive",
    action: "Action",
    templateName: "Product Name",
    templateCode: "Product Code",
  }
  bindConfigurationGrid(): void {
    console.log(this.productConfiguration_1);
    this.configurationGridView = process(this.productConfiguration_1, this.configurationGridstate);
  }
  loadConfigurationGrid(rp: IBBProductHierarchies): void {
    this.configurationLoading = true;
    //this.productConfiguration_1 = rp.configs;
    /*this.adminService.productMappingData.map((obj) => ({
    id: obj.configId, description: obj.configDescription, imageUrl: obj.configImageUrl, name: obj.configName, isActive: obj.isCofigActive,
    productSubCategoryId: obj.subCategoryId, subCategoryName: obj.subCategoryName, subCategoryImageUrl: obj.subCategoryImageUrl,
    categoryId: obj.categoryId, categoryName: obj.categoryName, categoryImageUrl: obj.categoryImageUrl, productName: obj.templateName, productId: obj.templateId,
    productCode: obj.templateCode, configLanguageCode: obj.configLanguageCode,
    configUniqueID: obj.configUniqueID
  }))
    //.filter(c => c.id != '0');
    .filter(
      (thing, i, arr) => arr.findIndex(t => t.configUniqueID === thing.configUniqueID && t.configLanguageCode === thing.configLanguageCode) === i
    )*/
    this.bindConfigurationGrid();
    this.configurationLoading = false;
  }
  configurationDataStateChange(state: DataStateChangeEvent): void {
    this.configurationGridstate = state;
    this.bindConfigurationGrid();
  }
  configurationGridSortChange(sort: SortDescriptor[]): void {
    this.configurationGridstate.sort = sort;
    this.bindConfigurationGrid();
  }
  configurationGridPageChange({ skip, take }: PageChangeEvent): void {
    this.configurationGridstate.skip = skip;
    this.categoryGridstate.take = take;
    this.bindConfigurationGrid();
  }

  configurationModel: any = this.resetConfigurationModel();
  configModalCategoryDropdownData: IBBPrductCategory[] = [];
  configModalSubCatDropdownData: IBBProductSubCategory[] = [];
  configModal_1: BBConfigModal;
  bindConfigProductCategoryDropData(languageCode) {
    this.configModal_1.catList = this.productCategory_1.filter(x => x.isActive && x.languageCode == languageCode);

    //this.configModalCategoryDropdownData = [];
    //this.configModalCategoryDropdownData = this.productCategory_1.filter(x => x.isActive && x.languageCode == languageCode);// show only active entries here.filter(r => r.ac == languageCode);
  }

  configModalLanguageChange(event) {
    this.configModal_1.languageCode = event.languageCode;
    this.configModal_1.selectedCat = new BBPrductCategory();
    this.configModal_1.selectedSubCat = new BBProductSubCategory();
    this.configModal_1.catList = this.productCategory_1.filter(x => x.isActive && x.languageCode == event.languageCode);
    this.configModal_1.subCatList = [];
    ////this.configurationModel.languageCode = event.languageCode;
    //this.configurationModel.productCategory = {};
    //this.configurationModel.productSubCategory = {};
    //this.bindConfigProductCategoryDropData(event.languageCode);
    //this.configModalSubCatDropdownData = [];
  }
  configModalCategoryChange(event) {
    console.log("1", this.configModal_1.selectedCat);
    this.configModal_1.selectedCat = event;
    console.log("2", this.configModal_1.selectedCat);
    console.log("3", event);
    this.configModal_1.selectedSubCat = new BBProductSubCategory();
    this.configModal_1.subCatList = this.productSubCategory_1.filter(x => x.isActive
      && x.productCategoryUniqueId == event.uniqueId
      && x.languageCode == this.configModal_1.languageCode);
    //this.configurationModel.productCategory = event;
    //this.configModalSubCatDropdownData = this.productSubCategory_1.filter(x => x.isActive
    //&& x.productCategoryUniqueId == event.uniqueId);
    //&& x.languageCode==even)
    //this.loadSubCategory();
    //this.validateProductConfigurationForm();
  }
  configModalSubCatChange(event) { }
  configModalTemplateFilter(event) {
    this.configModal_1.productTemplateList = this.productTemplates_1.filter(
      (s) => s ? s.productCode.toLowerCase().indexOf(event.toLowerCase()) !== -1 : false
    );
    //this.availableProducts = searchResult.length > 20 ? searchResult.slice(0, 20) : searchResult;
  }
  configModalTemplateChange(event) { }
  addProductConfiguration() {
    this.configModal_1 = new BBConfigModal();
    this.configModal_1.productTemplateList = this.productTemplates_1;
    this.productConfigurationDialog = this.resetProductConfigurationDialog();
    this.productConfigurationDialog.opened = true;
    this.productConfigurationDialog.title = "Add Configuration";
    this.disableProductSelect = false;
    this.imageConfigSrc = null;
    this.shouldShowConfigModalError = false;
    //this.configurationModel = this.resetConfigurationModel();
    //this.bindConfigProductCategoryDropData(localStorage.getItem('language'));
  }
  editproductConfiguration(dataItem) {
    console.log("5", dataItem);
    console.log(typeof (dataItem));
    this.shouldShowConfigModalError = true;
    this.productConfigurationDialog = this.resetProductConfigurationDialog();
    this.configModal_1 = new BBConfigModal();
    this.mapConfigObjcetToConfigModalObject(dataItem, this.configModal_1);
    this.configModal_1.catList = this.productCategory_1.filter(x =>
      x.languageCode == this.configModal_1.languageCode);
    this.configModal_1.selectedCat = this.productCategory_1.find(x =>
      x.uniqueId == this.configModal_1.catUniqueId);
    if (this.configModal_1.selectedCat) {
      this.configModal_1.subCatList = this.productSubCategory_1.filter(x =>
        x.languageCode == this.configModal_1.languageCode
        && x.productCategoryUniqueId == this.configModal_1.selectedCat.uniqueId);
      this.configModal_1.selectedSubCat = this.productSubCategory_1.find(x =>
        x.uniqueId == this.configModal_1.subCatUniqueId);
    }
    this.configModal_1.productTemplateList = this.productTemplates_1;
    this.configModal_1.selectedTemplate = this.productTemplates_1.find(x =>
      x.productCode == this.configModal_1.productCode);

    //this.configurationModel = dataItem;
    // this.configurationModel.productCategory = this.productCategory.find(r => r.id === dataItem.categoryId);
    //if (this.configurationModel.productCategory) {
    //  this.loadSubCategory();
    //  this.configurationModel.productSubCategory = this.productSubCategoryByCategoryId.find(r => r.id === dataItem.productSubCategoryId);
    //  if (dataItem.productId) {
    //    this.configurationModel.product = this.products.find(p => p.id === dataItem.productId);
    //    // this.disableProductSelect = true;//change as per requirement
    //  }
    //}
    //this.configurationModel.languageCode = dataItem.configLanguageCode;
    //this.bindConfigProductCategoryDropData(dataItem.configLanguageCode);
    this.imageConfigSrc = this.configurationModel.imageUrl;
    this.productConfigurationDialog.opened = true;
    this.productConfigurationDialog.title = "Edit Configuration";
  }
  mapConfigObjcetToConfigModalObject(config, configModal: BBConfigModal) {
    configModal.catImageUrl = config.catImageUrl;//
    configModal.catName = config.catName;// "Impact Entrances"
    configModal.catUniqueId = config.catUniqueId;// 2
    configModal.description = config.description;// "Single/Pair Door and/or Immediate/Transom Frame"
    configModal.id = config.id;// 9
    configModal.imageUrl = config.imageUrl;// "350-500 Heavy Wall/HW-IMMED.jfif"
    configModal.isActive = config.isActive;// true
    configModal.languageCode = config.languageCode;// undefined
    configModal.name = config.name;// "Single/Pair Door and/or Immediate/Transom Frame"
    //configModal.productCategory = config.productCategory;// undefined
    configModal.productCode = config.productCode;// "STD_DR_2DO"
    configModal.imageUrl = config.productImageUrl;// "http = config.;////noatdc-bcswb912 = config.;//6082/ResourceCenter/Content/ProductImages/undefined"
    configModal.productTemplateName = config.productTemplateName;// "190/350/500 Standard Entrance - Single or Pair 2 Door Openings"
    configModal.subCatImageUrl = config.subCatImageUrl;// "http = config.;////noatdc-bcswb912 = config.;//6082/ResourceCenter/Content/ProductImages/Swing%20Entrances/PROD-HW.jfif"
    configModal.subCatName = config.subCatName;// "350/500 Heavy Wall"
    configModal.subCatUniqueId = config.subCatUniqueId;// 2
    configModal.uniqueId = config.uniqueId;// 9
  }
  validateProductConfigurationForm(): boolean {
    //if (this.productConfigurationDialog.isSubmitted) {
    //  let isInvalid = false;
    let isValid = true;
    this.productConfigurationDialog.isEmptyProductCategory = true;
    this.productConfigurationDialog.isEmptyProductSubCategory = true;
    this.productConfigurationDialog.isEmptyName = false;
    this.productConfigurationDialog.isEmptyDescription = false;
    this.productConfigurationDialog.isEmptyLanguage = false;
    this.productConfigurationDialog.isEmptyTemplate = true;

    if (this.configModal_1.selectedTemplate && this.configModal_1.selectedTemplate.id > 0) {
      this.productConfigurationDialog.isEmptyTemplate = false;
    }

    if (this.configModal_1.selectedCat && this.configModal_1.selectedCat.uniqueId > 0) {
      this.productConfigurationDialog.isEmptyProductCategory = false;
    }
    if (this.configModal_1.selectedSubCat && this.configModal_1.selectedSubCat.uniqueId > 0) {
      this.productConfigurationDialog.isEmptyProductSubCategory = false;
    }
    if (!this.configModal_1.name) {
      this.productConfigurationDialog.isEmptyName = true;
    }
    if (!this.configModal_1.description) {
      this.productConfigurationDialog.isEmptyDescription = true;
    }
    if (!this.configModal_1.languageCode) {
      this.productConfigurationDialog.isEmptyLanguage = true;
    }
    if (
      this.productConfigurationDialog.isEmptyProductCategory ||
      this.productConfigurationDialog.isEmptyProductSubCategory ||
      this.productConfigurationDialog.isEmptyName ||
      this.productConfigurationDialog.isEmptyDescription ||
      this.productConfigurationDialog.isEmptyLanguage ||
      this.productConfigurationDialog.isEmptyTemplate
    ) {
      isValid = false;
    }
    return isValid;
  }
  shouldShowConfigModalError = false;
  saveProductConfiguration() {
    this.shouldShowConfigModalError = true;
    if (!this.validateProductConfigurationForm()) {
      return;
    }
    if (!this.isConfigFileUploaded) {
      this.configModal_1.imageUrl = null;
    }
    let pId = this.configModal_1.selectedTemplate ? this.configModal_1.selectedTemplate.id : 0;
    const body = {
      id: this.configModal_1.id ? +this.configModal_1.id : 0,
      name: this.configModal_1.name,
      imageUrl: this.configModal_1.imageUrl,
      description: this.configModal_1.description,
      isActive: this.configModal_1.isActive,
      subCategoryId: +this.configModal_1.selectedSubCat.uniqueId,
      productId: pId ? pId : 0,
      subCategoryName: this.configModal_1.selectedSubCat.name,
      languageCode: this.configModal_1.languageCode,
      configUniqueID: this.configModal_1.uniqueId ? +this.configModal_1.uniqueId : 0
    }
    console.log(body);
    this.productConfigurationDialog.saveInProcess = true;
    this.adminService.saveProductConfiguration(body)
      .subscribe(result => {
        console.log(result);
        this.addUpdateProductConfiguration(result);
        this.prepareConfigObjectsForDisplay();
        this.productConfigurationDialog.saveInProcess = false;
        this.productConfigurationDialog.opened = false;
        this.bindConfigurationGrid();
      }, (error) => {
        this.productConfigurationDialog.saveInProcess = false;
      });

  }
  addUpdateProductConfiguration(item: IBBPrductConfiguration) {
    if (item) {
      //if (!this.disableProductSelect) {
      //  var tempAvailableProductIndex = this.availableProducts.findIndex(p => p.id === +item.productId);
      //  var tempProductIndex = this.products.findIndex(p => p.id === +item.productId);
      //  var tempProduct = this.products.find(p => p.id === +item.productId);
      //  tempProduct.productId = +item.id;
      //  if (tempAvailableProductIndex > -1)
      //    this.availableProducts.splice(tempAvailableProductIndex, 1);
      //  if (tempProductIndex > -1)
      //    this.products.splice(tempProductIndex, 1, tempProduct);
      //}
      const tempIndex = this.productConfiguration_1.findIndex(r => r.uniqueId === item.uniqueId);
      if (tempIndex > -1) {
        this.productConfiguration_1.splice(tempIndex, 1, item);
      } else {
        this.productConfiguration_1.splice(0, 0, item);
      }
    }
  }
  //#endregion

  //#region common delete item
  public removeType: string;
  public removeConfirmation(dataItem, type): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    this.removeType = type;
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.itemRemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
      this.removeType = "";
    }
  }
  protected itemRemoveHandler() {
    const itemId = this.gridItemToRemove.uniqueId;
    let body = {
      uniqueId: itemId
    }
    if (this.removeType == "Category") {
      this.productService.deleteProductCategory(body).subscribe(() => {
        this.gridItemToRemove = null;
        this.appNotifyService.notify(NotifyType.SUCCESS, "Selected item has been removed.");
        if (this.productCategory_1) {
          //This is a Local Remove
          const index = (this.productCategory_1).findIndex(r => r.uniqueId === itemId);
          (this.productCategory_1).splice(index, 1);
          this.bindCategoryGrid();
          this.prepareSubCatObjectsForDisplay();
          this.prepareConfigObjectsForDisplay();
          this.bindSubCategoryGrid();
          this.bindConfigurationGrid();
        }

      }, error => {
        //this following region is only for test, just show error and forget
        //this.gridItemToRemove = null;
        //if (this.productCategory_1) {
        //  //This is a Local Remove
        //  const index = (this.productCategory_1).findIndex(r => r.uniqueId === itemId);
        //  (this.productCategory_1).splice(index, 1);
        //  this.bindCategoryGrid();
        //}
        this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
      });
    }
    else if (this.removeType == "SubCategory") {
      this.productService.deleteProductSubCategory(body).subscribe(() => {
        this.gridItemToRemove = null;
        this.appNotifyService.notify(NotifyType.SUCCESS, "Selected item has been removed.");
        if (this.productSubCategory) {
          //This is a Local Remove
          const index = (this.productSubCategory_1).findIndex(r => r.uniqueId === itemId);
          (this.productSubCategory_1).splice(index, 1);
          this.bindSubCategoryGrid();
          this.prepareConfigObjectsForDisplay();
          this.bindConfigurationGrid();
        }

      }, error => {
        this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
      });
    }
    else if (this.removeType == "Config") {
      this.productService.deleteProductConfiguration(body).subscribe(() => {
        this.gridItemToRemove = null;
        this.appNotifyService.notify(NotifyType.SUCCESS, "Selected item has been removed.");
        if (this.productConfiguration) {
          //This is a Local Remove
          const index = (this.productConfiguration_1).findIndex(r => r.uniqueId === itemId);
          (this.productConfiguration_1).splice(index, 1);
          this.bindConfigurationGrid();
        }

      }, error => {
        this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
      });
    }
    this.removeType = "";
  }
  //#endregion

  //#endregion

}
